import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { mainStore } from '@/stores/mainStore';
import { IonApp, IonRouterOutlet,IonLoading,IonNote } from '@ionic/vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const mainStoreInstance = mainStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonLoading), {
        "is-open": _unref(mainStoreInstance).$state.loading.show,
        message: _unref(mainStoreInstance).$state.loading.message
      }, null, 8, ["is-open", "message"]),
      _createVNode(_unref(IonRouterOutlet))
    ]),
    _: 1
  }))
}
}

})